import Textfield from 'shared/components/Textfield'
import Button from 'shared/components/Button'

import '@booking/styles.scss'

const PromoCode = ({
    onRemovePromoCode,
    onAddPromoCode,
    btnLabel,
    btnStyle,
    removePromoCodeLabel,
    label,
    placeholder,
    isLoading,
    disabled,
    success,
    error,
    promoCodeValue,
    setRawPromoCode,
}) => {
    const [isErrorVisible, setIsErrorVisible] = React.useState(false)

    React.useEffect(() => {
        if (promoCodeValue && error) setIsErrorVisible(true)
    }, [error])

    const onPromoCodeValueChange = e => {
        setIsErrorVisible(false)
        setRawPromoCode(e.target.value.toUpperCase())
    }

    const onRemove = () => {
        setRawPromoCode('')
        onRemovePromoCode()
    }

    const onSubmitHandler = e => {
        e.preventDefault()
    }

    return (
        <form onSubmit={onSubmitHandler}>
            {label && (
                <p>
                    <b>{label}</b>
                </p>
            )}
            <div className="d-flex align-items-start">
                <div className="d-flex flex-column align-items-end w-100">
                    <Textfield
                        id="promo__code"
                        className={`booking__promocode ${isErrorVisible && 'booking__promocode_error'}`}
                        value={promoCodeValue}
                        onChange={onPromoCodeValueChange}
                        label={placeholder}
                        disabled={disabled}
                        status={success ? 'success' : undefined}
                        iconRight={success ? 'checked' : undefined}
                        readOnly={!!success}
                        setShowError={setIsErrorVisible}
                    />
                    {success && (
                        <Button
                            onClick={onRemove}
                            className="booking__select__button"
                            btnStyle="link"
                            size="small"
                            iconLeft="minus-round">
                            {removePromoCodeLabel}
                        </Button>
                    )}
                </div>

                <Button
                    onClick={() => onAddPromoCode(promoCodeValue)}
                    disabled={disabled || success || promoCodeValue === ''}
                    isLoading={isLoading}
                    btnStyle={btnStyle || 'outline'}
                    size="large"
                    className="ml-1">
                    {btnLabel}
                </Button>
            </div>
            {error && isErrorVisible && <div className="mt-2 error-text">{error}</div>}
        </form>
    )
}

PromoCode.propTypes = {
    btnLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    removePromoCodeLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    success: PropTypes.bool,
    isLoading: PropTypes.bool,
    disabled: PropTypes.bool,
    onRemovePromoCode: PropTypes.func,
    onAddPromoCode: PropTypes.func,
    initialValue: PropTypes.string,
}

export default PromoCode
